import { useEffect, useRef, useState } from 'react';

// Animates from 0 to `target` over `duration` ms using requestAnimationFrame.
// Re-runs whenever target changes. No dependencies.
export function useCountUp(target, duration = 900) {
  const [value, setValue] = useState(0);
  const rafRef = useRef(null);
  const startRef = useRef(null);
  const fromRef = useRef(0);

  useEffect(() => {
    const to = Number(target) || 0;
    fromRef.current = 0;
    startRef.current = null;

    const tick = (ts) => {
      if (startRef.current === null) startRef.current = ts;
      const elapsed = ts - startRef.current;
      const p = Math.min(elapsed / duration, 1);
      // easeOutCubic
      const eased = 1 - Math.pow(1 - p, 3);
      setValue(fromRef.current + (to - fromRef.current) * eased);
      if (p < 1) rafRef.current = requestAnimationFrame(tick);
      else setValue(to);
    };

    rafRef.current = requestAnimationFrame(tick);
    return () => { if (rafRef.current) cancelAnimationFrame(rafRef.current); };
  }, [target, duration]);

  return value;
}
